import DropDown, { DropDownProps } from './Dropdown.component';

export type TDropDown = DropDownProps;

export default DropDown;
